import { Link, useLocation } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import '../../../Airoom.css';
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import Select, { StylesConfig } from "react-select";
import TextField from "../../../core/common/textFields/TextField";


const LeadsUserDetail = () => {
    const location = useLocation();
    const path = location.pathname;
    const isReadOnly = location.pathname.includes('leadsUserDetails');
    const actionbutton = location.pathname.includes('editLead') ? 'Update' : 'Save';

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const options1 = [
        { value: "Select a View", label: "Select a View" },
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "To be Rehashed", label: "To be Rehashed" },
        { value: "Sold", label: "Sold" },


    ];
    const options2 = [
        { value: "Choose", label: "Choose" },
        { value: "Walk-in", label: "Walk-in" },
        { value: "Phone Call", label: "Phone Call" },
        { value: "Website Inquiry", label: "Website Inquiry" },
        { value: "Referral", label: "Referral" },
        { value: "Already a Customer", label: "Already a Customer" },
    ];
    const options3 = [
        { value: "Choose", label: "Choose" },
        { value: "High", label: "High" },
        { value: "Low", label: "Low" },
        { value: "Medium", label: "Medium" },

    ]

    return (
        <>
            {location.pathname.includes('leadsUserDetails') ? ('') : (
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-primary">{actionbutton}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}
            <div className="row">
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="card-body">
                                    <h5>
                                        Client Details
                                    </h5>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Name "
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Sale Accepted Date "
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Address"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Region"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Zip Code"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Home Phone"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Work Phone"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Cell Phone"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Home Phone"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Home Email"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Work Email"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Preffered Contact Method"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Preffered Contact Time"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <h5>Project Details</h5>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Sale Price"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="No. of Contingencies"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Cash"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Project Cost Amount"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="No. of Warrenty Exclusives"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Using LFC"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Rev Cost Amount"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Owner's Bank"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Plan Dues Amount"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Finance"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Down Payment"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <h4>
                                        Project Info
                                    </h4>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Contact ID"
                                            type="text"
                                            // {...formik.getFieldProps("workEmail")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                                                   
                        
                    </div>
                </div>
                {(location.pathname.includes('leadsUserDetails') || location.pathname.includes('editLead')) && (<>
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-2 align-items-center">
                                    <h5>Time Line</h5>
                                    <div className="d-flex gap-2 align-items-center">
                                        <div className="form-sorts filter-css dropdown">
                                            <Link
                                                to="#"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="false"
                                            >
                                                <i className="ti ti-filter-share" />
                                            </Link>
                                            <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end">
                                                <div className="filter-set-view">
                                                    <div className="filter-set-head">
                                                        <h4>
                                                            <i className="ti ti-filter-share" />
                                                            Filter
                                                        </h4>
                                                    </div>

                                                    <div
                                                        className="accordion"
                                                        id="accordionExample"
                                                    >
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapseTwo"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapseTwo"
                                                                >
                                                                    Name
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse show"
                                                                id="collapseTwo"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search "
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Darlee Robertson</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5> Sharon Roy</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Robertson</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Sharon</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jessica</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Carol Thomas</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Thomas</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jessica</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#phone"
                                                                    aria-expanded="false"
                                                                    aria-controls="phone"
                                                                >
                                                                    Phone
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="phone"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Owner"
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Hendry</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Guillory</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jami</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Theresa</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Espinosa</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#email"
                                                                    aria-expanded="false"
                                                                    aria-controls="email"
                                                                >
                                                                    Email
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="email"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Owner"
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Hendry</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Guillory</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jami</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Theresa</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Espinosa</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#role"
                                                                    aria-expanded="false"
                                                                    aria-controls="role"
                                                                >
                                                                    Role
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="role"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Owner"
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Hendry</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Guillory</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jami</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Theresa</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Espinosa</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#location"
                                                                    aria-expanded="false"
                                                                    aria-controls="location"
                                                                >
                                                                    Location
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="location"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Owner"
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Hendry</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Guillory</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jami</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Theresa</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Espinosa</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#createDate"
                                                                    aria-expanded="false"
                                                                    aria-controls="createDate"
                                                                >
                                                                    Created Date
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="createDate"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <div className="form-wrap icon-form">
                                                                        <span className="form-icon">
                                                                            <i className="ti ti-search" />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Owner"
                                                                        />
                                                                    </div>
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Hendry</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Guillory</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Jami</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Theresa</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Espinosa</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="filter-set-content">
                                                            <div className="filter-set-content-head">
                                                                <Link
                                                                    to="#"
                                                                    className="collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Status"
                                                                    aria-expanded="false"
                                                                    aria-controls="Status"
                                                                >
                                                                    Status
                                                                </Link>
                                                            </div>
                                                            <div
                                                                className="filter-set-contents accordion-collapse collapse"
                                                                id="Status"
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="filter-content-list">
                                                                    <ul>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        defaultChecked
                                                                                    />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Active</h5>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="filter-checks">
                                                                                <label className="checkboxs">
                                                                                    <input type="checkbox" />
                                                                                    <span className="checkmarks" />
                                                                                </label>
                                                                            </div>
                                                                            <div className="collapse-inside-text">
                                                                                <h5>Inactive</h5>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="filter-reset-btns">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <Link
                                                                    to="#"
                                                                    className="btn btn-light"
                                                                >
                                                                    Reset
                                                                </Link>
                                                            </div>
                                                            <div className="col-6">
                                                                <Link
                                                                    to="#"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Apply
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {svgIcons.sorterIcon}
                                        </div>
                                    </div>
                                </div>
                                <div className=" icon-form">
                                    <span className="form-icon">
                                        <i className="ti ti-search" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                    />
                                </div>

                                <div className="noti-content mt-2">
                                    <ul className="notification-list">
                                        <li className="notification-message">
                                            <Link to='#'>
                                                <div className="media d-flex gap-3 align-items-center">
                                                    <span className="avatar timeline-img flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/profiles/profile-img.jpg"
                                                            alt="Profile"
                                                            className="timeline-img"
                                                        />
                                                        <span className="badge badge-info rounded-pill" />
                                                    </span>
                                                    <div className="media-body flex-grow-1">
                                                        <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By Linda</h6>
                                                        <p className="noti-details mb-0">
                                                            Meeting with client & Linda
                                                        </p>
                                                        <div className="d-flex gap-2">
                                                            <p className="noti-time mt-2 mb-0">
                                                                9/29/2024
                                                            </p>
                                                            <p className="noti-time mt-2 mb-0">
                                                                03:36 PM
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <hr />
                                        <li className="notification-message">
                                            <Link to='#'>
                                                <div className="media d-flex gap-3 align-items-center">
                                                    <span className="avatar timeline-img flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/profiles/profile-img.jpg"
                                                            alt="Profile"
                                                            className="timeline-img"
                                                        />
                                                        <span className="badge badge-info rounded-pill" />
                                                    </span>
                                                    <div className="media-body flex-grow-1">
                                                        <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By John</h6>
                                                        <p className="noti-details mb-0">
                                                            Meeting with client & John
                                                        </p>
                                                        <div className="d-flex gap-2">
                                                            <p className="noti-time mt-2 mb-0">
                                                                7/28/2024
                                                            </p>
                                                            <p className="noti-time mt-2 mb-0">
                                                                04:16 PM
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>

                                </div>
                                <hr />
                                <div className="noti-content">
                                    <ul className="notification-list">
                                        <li className="notification-message">
                                            <Link to='#'>
                                                <div className="media d-flex gap-3 align-items-center">
                                                    <span className="avatar timeline-img flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/profiles/profile-img.jpg"
                                                            alt="Profile"
                                                            className="timeline-img"
                                                        />
                                                        <span className="badge badge-info rounded-pill" />
                                                    </span>
                                                    <div className="media-body flex-grow-1">
                                                        <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By smith</h6>
                                                        <p className="noti-details mb-0">
                                                            Meeting with client & smith
                                                        </p>
                                                        <div className="d-flex gap-2">
                                                            <p className="noti-time mt-2 mb-0">
                                                                10/29/2024
                                                            </p>
                                                            <p className="noti-time mt-2 mb-0">
                                                                05:32 PM
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <hr />
                                        <li className="notification-message">
                                            <Link to='#'>
                                                <div className="media d-flex gap-3 align-items-center">
                                                    <span className="avatar timeline-img flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/profiles/profile-img.jpg"
                                                            alt="Profile"
                                                            className="timeline-img"
                                                        />
                                                        <span className="badge badge-info rounded-pill" />
                                                    </span>
                                                    <div className="media-body flex-grow-1">
                                                        <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By Michael</h6>
                                                        <p className="noti-details mb-0">
                                                            Meeting with client & Michael
                                                        </p>
                                                        <div className="d-flex gap-2">
                                                            <p className="noti-time mt-2 mb-0">
                                                                12/19/2024
                                                            </p>
                                                            <p className="noti-time mt-2 mb-0">
                                                                02:12 PM
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
            </div>
        </>
    )
}

export default LeadsUserDetail
